import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-view-toggle',
  standalone: true,
  imports: [CommonModule, MatIconModule, TranslatePipe],
  templateUrl: './view-toggle.component.html',
  styleUrl: './view-toggle.component.css'
})
export class ViewToggleComponent {
  value = input<'table' | 'cards'>('table');
  valueChange = output<'table' | 'cards'>();

  setTable(): void {
    this.valueChange.emit('table');
  }

  setCards(): void {
    this.valueChange.emit('cards');
  }
}
